import React from 'react';
import { useParams } from 'react-router-dom';
import EstablishmentDetailV2 from 'modules/establishment/detail/EstablishmentDetailV2';
import DashHeader from 'modules/dashboard/_common/DashHeader';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';
import LoginModal from 'modules/onboarding/sign-in/LoginModal';
import { ShowLoginModalProvider, useShowLoginModal } from 'context/general/ShowLoginModal';
import OnSelectMenuProvider from 'context/general/OnSelectMenu';
import CollapseProvider from 'context/general/Collapse';
import styled from 'styled-components';
import breakpoints from 'theme/breakpoints';

function EstablishmentDetailPageInner() {
    const { slug } = useParams();
    const { showLoginModal, setShowLoginModal } = useShowLoginModal();

    return (
        <>
            <StyledHeader>
                <DashHeader userView={true} />
                <DashHeaderActions />
            </StyledHeader>
            <PageContent>
                <EstablishmentDetailV2 slug={slug} />
            </PageContent>
            <LoginModal
                isOpen={showLoginModal}
                onClose={() => setShowLoginModal(false)}
            />
        </>
    );
}

export default function EstablishmentDetailPage() {
    return (
        <OnSelectMenuProvider>
            <CollapseProvider>
                <ShowLoginModalProvider>
                    <EstablishmentDetailPageInner />
                </ShowLoginModalProvider>
            </CollapseProvider>
        </OnSelectMenuProvider>
    );
}

const StyledHeader = styled.span`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;

const PageContent = styled.div`
    @media screen and (min-width: ${breakpoints.lg}) {
        padding-top: 98px;
    }
`;
